// removed by extract-text-webpack-plugin
module.exports = {"droparea":"_3k84J58tmNxstNb4HPO5-p","primary":"_37Zf3jK9JC0py34oYZMJ3a","icon":"WYCuRFdPuh5qxn5eb_yhA","dragover":"_2ztXxJhcb1XELAw30mE6eP","btn":"_22GP6xQnZGeX3mIWmGRIq-","msgDefault":"_2WCD-8TfRBWMyWPpFdOK9z","msgDrop":"_3vlm5vC9OOtUv-l-WkA9gy","fileUpload":"Pavt6Aabmdp0O81u_9zuS"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/molecules/ImageDropArea-v1/style.css
// module id = 520
// module chunks = 38